export const styles = {
	field: {
		marginBottom: 1,
		width: 400,
		display: 'flex'
	},
	error: {
		color: 'red',
		marginTop: 1,
		marginLeft: 1
	}
};
